import { CenterLecComment } from '../../../lib/types/models/center-lec-comment/center-lec-comment'
import { CenterLecCommentInput } from '../../../lib/types/models/center-lec-comment/center-lec-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateCenterLecComment = async (
  data: UpdateInput<CenterLecCommentInput> & { centerId: number }
) => {
  const { id, centerId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterLecComment.url, { id, centerId }))
    .patch<CenterLecComment, Partial<CenterLecCommentInput>>(rest)
}
